/* ==========================================================================
   Enter your measurements (sections/ivp-measure-form.liquid, 7 Oct 2026)
   - the garment choice shows its measurements and enables only that set (so only it is validated and sent); a vest
     uses the jacket set without the arm measurements (8 Oct 2026)
   - ?type=suit|jacket|vest|pants, ?order= and ?product= fill the form (links from product pages and the team's emails)
   - the drawing (snippets/ivp-measure-figure.liquid): the field being filled lights up on it, typed values show beside
     the chart's numbers/letters; on phones a close-up opens under the field being filled (8 Oct 2026)
   - on send: the answers also go to the garment's Google Form (the sheet the team uses), then the store's contact
     form sends as usual (store inbox + the thank-you). The Google copy is best effort: the contact email always goes.
   ========================================================================== */
(function () {
  'use strict';
  var form = document.getElementById('IvpMeasureForm');
  if (!form) return;
  var sets = Array.prototype.slice.call(form.querySelectorAll('[data-ivp-garment-set]'));
  var radios = Array.prototype.slice.call(form.querySelectorAll('[data-ivp-garment]'));
  if (!sets.length) return;
  var VEST_NA = 'N/A – vest';
  var current = null;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function known(g) { return radios.some(function (r) { return r.getAttribute('data-ivp-garment') === g; }); }
  function setKey(g) { return g === 'vest' ? 'jacket' : g; }

  /* ---------- Garment ---------- */
  function show(g, keepUrl) {
    if (!known(g)) return;
    current = g;
    var key = setKey(g), vest = g === 'vest';
    sets.forEach(function (fs) {
      var on = fs.getAttribute('data-ivp-garment-set') === key;
      fs.disabled = !on;
      fs.hidden = !on;
      if (!on) return;
      fs.classList.toggle('is-vest', vest);
      var name = fs.querySelector('[data-ivp-gname]');
      if (name) name.textContent = (vest && fs.getAttribute('data-vest-label')) || fs.getAttribute('data-label') || '';
      each(fs.querySelectorAll('[data-skip-vest]'), function (inp) {
        inp.disabled = vest;
        var row = inp.closest('.ivp-measure__m');
        if (row) row.hidden = vest;
        marks(fs, inp.getAttribute('data-ivp-mark')).forEach(function (m) { m.hidden = vest; });
      });
      refresh(fs);
    });
    radios.forEach(function (r) { r.checked = r.getAttribute('data-ivp-garment') === g; });
    if (!keepUrl && window.history && history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('type', g);
      history.replaceState(history.state, '', u.toString());
    }
  }
  radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) show(r.getAttribute('data-ivp-garment')); }); });

  /* ---------- Drawing ---------- */
  function marks(scope, code) {
    if (!code) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('[data-ivp-fig-mark]')).filter(function (m) { return m.getAttribute('data-ivp-fig-mark') === code; });
  }
  function setValue(inp) {
    var fs = inp.closest('[data-ivp-garment-set]');
    if (!fs) return;
    var v = String(inp.value || '').trim();
    marks(fs, inp.getAttribute('data-ivp-mark')).forEach(function (m) {
      m.classList.toggle('has-value', v !== '');
      var t = m.querySelector('[data-ivp-v]');
      if (t) t.textContent = v !== '' ? v + ' cm' : (m.classList.contains('is-active') ? '… cm' : '');
    });
    var box = fs.querySelector('[data-ivp-peek]');
    if (box && box._inp === inp) badge(box, inp);
  }
  // the close-up's own label (its tags would be cut off at the edges): code and value
  function badge(box, inp) {
    var el = box.querySelector('[data-ivp-peek-val]');
    if (!el) return;
    var v = String(inp.value || '').trim();
    el.innerHTML = '';
    var b = document.createElement('b'); b.textContent = inp.getAttribute('data-ivp-mark');
    el.appendChild(b);
    el.appendChild(document.createTextNode(v !== '' ? v + ' cm' : '… cm'));
  }
  function refresh(fs) { each(fs.querySelectorAll('[data-ivp-mark]'), setValue); }
  function caption(fs, inp) {
    var cap = fs.querySelector('[data-ivp-fig-cap]');
    if (!cap) return;
    if (!inp) { cap.className = 'ivp-fig__cap ivp-fig__cap--idle'; cap.textContent = cap.getAttribute('data-idle') || ''; return; }
    var row = inp.closest('.ivp-measure__m');
    var label = row && row.querySelector('.ivp-measure__t strong');
    var how = row && row.querySelector('.ivp-measure__t small');
    cap.className = 'ivp-fig__cap';
    cap.textContent = '';
    var b = document.createElement('b'); b.textContent = inp.getAttribute('data-ivp-mark');
    var span = document.createElement('span');
    var strong = document.createElement('strong'); strong.textContent = label ? label.textContent : '';
    span.appendChild(strong);
    if (how && how.textContent) span.appendChild(document.createTextNode(' · ' + how.textContent));
    cap.appendChild(b); cap.appendChild(span);
  }
  var mq = window.matchMedia ? window.matchMedia('(max-width: 999px)') : { matches: false };
  // phones: a close-up of the drawing under the field being filled (the overview sits above the list)
  function peek(fs, inp) {
    var box = fs.querySelector('[data-ivp-peek]');
    if (!mq.matches) { if (box) box.hidden = true; return; }
    var row = inp.closest('.ivp-measure__m');
    var svg = fs.querySelector('[data-ivp-fig] .ivp-fig__svg');
    if (!row || !svg) return;
    if (!box) {
      box = document.createElement('div');
      box.className = 'ivp-fig ivp-fig--peek has-active';
      box.setAttribute('data-ivp-peek', '');
      box.setAttribute('aria-hidden', 'true');
      var clone = svg.cloneNode(true);
      clone.removeAttribute('role'); clone.removeAttribute('aria-label');
      box.appendChild(clone);
      var val = document.createElement('p');
      val.className = 'ivp-fig__peekval';
      val.setAttribute('data-ivp-peek-val', '');
      box.appendChild(val);
    }
    box._inp = inp;
    badge(box, inp);
    if (row.nextElementSibling !== box) row.parentNode.insertBefore(box, row.nextSibling);
    box.hidden = false;
    var csvg = box.querySelector('svg');
    var base = svg.getAttribute('viewBox').split(' ').map(Number);
    var lns = [];
    marks(box, inp.getAttribute('data-ivp-mark')).forEach(function (m) { each(m.querySelectorAll('.ivp-fig__ln'), function (l) { lns.push(l); }); });
    if (!lns.length) { csvg.setAttribute('viewBox', base.join(' ')); return; }
    var y0 = Infinity, y1 = -Infinity;
    lns.forEach(function (l) { var bb = l.getBBox(); y0 = Math.min(y0, bb.y); y1 = Math.max(y1, bb.y + bb.height); });
    var h = Math.min(Math.max(280, y1 - y0 + 90), 560);
    var y = Math.max(base[1], Math.min((y0 + y1) / 2 - h / 2, base[1] + base[3] - h));
    csvg.setAttribute('viewBox', '110 ' + Math.round(y) + ' 420 ' + Math.round(h));
  }
  function activate(inp) {
    var fs = inp.closest('[data-ivp-garment-set]');
    if (!fs) return;
    each(fs.querySelectorAll('.ivp-fig__mk.is-active'), function (m) { m.classList.remove('is-active'); });
    each(fs.querySelectorAll('[data-ivp-fig]'), function (fig) { fig.classList.add('has-active'); });
    marks(fs, inp.getAttribute('data-ivp-mark')).forEach(function (m) {
      m.classList.add('is-active');
      m.parentNode.appendChild(m); // on top of the other marks
    });
    refresh(fs);
    caption(fs, inp);
    peek(fs, inp);
  }
  function deactivate(fs) {
    each(fs.querySelectorAll('.ivp-fig__mk.is-active'), function (m) { m.classList.remove('is-active'); });
    each(fs.querySelectorAll('[data-ivp-fig]'), function (fig) { fig.classList.remove('has-active'); });
    var box = fs.querySelector('[data-ivp-peek]');
    if (box) box.hidden = true;
    refresh(fs);
    caption(fs, null);
  }
  sets.forEach(function (fs) {
    fs.addEventListener('focusin', function (e) { var inp = e.target.closest('[data-ivp-mark]'); if (inp) activate(inp); });
    fs.addEventListener('input', function (e) { var inp = e.target.closest('[data-ivp-mark]'); if (inp) setValue(inp); });
    fs.addEventListener('focusout', function () {
      setTimeout(function () { var a = document.activeElement; if (!a || !fs.contains(a) || !a.hasAttribute('data-ivp-mark')) deactivate(fs); }, 120);
    });
    // a mark on the drawing jumps to its field
    fs.addEventListener('click', function (e) {
      var m = e.target.closest && e.target.closest('[data-ivp-fig-mark]');
      if (!m || m.closest('[data-ivp-peek]')) return;
      var code = m.getAttribute('data-ivp-fig-mark');
      var inp = Array.prototype.slice.call(fs.querySelectorAll('[data-ivp-mark]')).filter(function (i) { return i.getAttribute('data-ivp-mark') === code && !i.disabled; })[0];
      if (inp) { inp.focus({ preventScroll: true }); inp.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    });
  });

  /* ---------- Start: URL first, else the garment the browser restored (a reload or Back keeps the last choice; the
     visible set used to stay on the race suit while another garment was ticked) ---------- */
  var q = new URLSearchParams(window.location.search);
  var type = (q.get('type') || '').toLowerCase();
  function fromChecked() { var c = radios.filter(function (r) { return r.checked; })[0]; return c ? c.getAttribute('data-ivp-garment') : 'suit'; }
  show(known(type) ? type : fromChecked(), !known(type));
  window.addEventListener('pageshow', function () { show(fromChecked(), true); });
  var order = form.querySelector('[data-ivp-order]');
  if (order && q.get('order')) order.value = q.get('order');
  var product = form.querySelector('[data-ivp-product]');
  if (product && q.get('product')) product.value = q.get('product');
  // old links to the retired custom order form (/pages/custom-order?handle=...&variant=..., now redirected here):
  // the product's name, and its garment when the link has no ?type
  var handle = q.get('handle');
  if (handle && /^[a-z0-9-]+$/.test(handle) && product && !product.value && window.fetch) {
    fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      product.value = String(p.title || '').split(' | ')[0];
      if (!known(type)) {
        var t = String(p.type || '').toLowerCase();
        show(/vest/.test(t) ? 'vest' : /jacket|hoodie|shirt/.test(t) ? 'jacket' : /trouser|jeans|pants|legging/.test(t) ? 'pants' : 'suit');
      }
    }).catch(function () {});
  }

  /* ---------- Copy to the Google Form ---------- */
  function googleCopy() {
    var set = sets.filter(function (fs) { return !fs.disabled; })[0];
    var id = set && set.getAttribute('data-gform');
    if (!id || !window.fetch) return Promise.resolve();
    var data = new URLSearchParams();
    // fields of the enabled garment plus the shared ones (rider details, about you, confirmation)
    each(form.querySelectorAll('[data-entry]'), function (el) {
      if (el.closest('fieldset:disabled')) return;
      // a vest has no arm measurements: the jacket form requires them, so they go as "N/A – vest"
      if (el.disabled) { if (current === 'vest' && el.hasAttribute('data-skip-vest')) data.append('entry.' + el.getAttribute('data-entry'), VEST_NA); return; }
      if (el.type === 'checkbox' && !el.checked) return;
      if (el.value === '') return;
      // the confirmation box sends the Google Form's own wording, whatever the visible text says
      data.append('entry.' + el.getAttribute('data-entry'), el.getAttribute('data-gvalue') || el.value);
    });
    // the forms have no order number field: it goes in front of "Model / Design Name"
    var ref = [order && order.value ? 'Order ' + order.value : '', current === 'vest' ? 'Vest' : '', product ? product.value : ''].filter(Boolean).join(' · ');
    if (ref) data.append('entry.858661273', ref);
    var pages = parseInt(set.getAttribute('data-gform-pages'), 10) || 1;
    var hist = [];
    for (var i = 0; i < pages; i++) hist.push(i);
    data.append('pageHistory', hist.join(','));
    // keepalive: the request survives the page moving on to the contact form submit (a slow upload was cut off)
    var post = fetch('https://docs.google.com/forms/d/e/' + id + '/formResponse', { method: 'POST', mode: 'no-cors', body: data, keepalive: true });
    var wait = new Promise(function (ok) { setTimeout(ok, 4000); });
    return Promise.race([post, wait]).catch(function () {});
  }

  var sending = false;
  form.addEventListener('submit', function (e) {
    if (sending) return;
    e.preventDefault();
    if (form.reportValidity && !form.reportValidity()) return;
    sending = true;
    var btn = form.querySelector('[data-ivp-measure-send]');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    googleCopy().then(function () { HTMLFormElement.prototype.submit.call(form); });
  });
})();
